export const JobEvent = {
  CUSTOMER_STARTED: 'job:customer-started',
  CUSTOMER_ACTIVITY_SELECTED: 'job:customer-activity-selected',
  SUBMITTED: 'job:submitted'
}
